module.exports = __webpack_public_path__ + "static/img/stamp_02.82cbfb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_02.jpg
// module id = qqIV
// module chunks = 7